import { render, staticRenderFns } from "./reviews-head.vue?vue&type=template&id=5281722a&scoped=true&"
import script from "./reviews-head.vue?vue&type=script&lang=js&"
export * from "./reviews-head.vue?vue&type=script&lang=js&"
import style0 from "./reviews-head.vue?vue&type=style&index=0&id=5281722a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5281722a",
  null
  
)

export default component.exports